import { Plug, Plus } from 'lucide-react';
import EmptyState from '../../../../components/patterns/EmptyState.jsx';
import Table from '../../../../components/patterns/Table.jsx';
import Avatar from '../../../../components/primitives/Avatar.jsx';
import Button from '../../../../components/primitives/Button.jsx';
import Card from '../../../../components/primitives/Card.jsx';
import Skeleton from '../../../../components/primitives/Skeleton.jsx';
import ExecutionStatus from '../../../../components/surfaces/ExecutionStatus.jsx';
import GalleryExample from './GalleryExample.jsx';
import GallerySection from './GallerySection.jsx';

const COLUMNS = [
  { key: 'automation', header: 'Automation' },
  { key: 'status', header: 'Status' },
  { key: 'started', header: 'Started' },
  { key: 'runId', header: 'Run ID', mono: true },
  { key: 'duration', header: 'Duration', align: 'end' }
];

const ROWS = [
  { id: 'r1', automation: 'Overdue invoice follow-up', status: <ExecutionStatus state="waiting" size="sm" />, started: 'Today, 9:00', runId: 'run_8f2c41', duration: '4m 12s' },
  { id: 'r2', automation: 'New HubSpot deals to Slack', status: <ExecutionStatus state="running" size="sm" />, started: 'Today, 9:14', runId: 'run_8f2c57', duration: '18s' },
  { id: 'r3', automation: 'Weekly sales summary', status: <ExecutionStatus state="done" size="sm" />, started: 'Yesterday, 17:00', runId: 'run_8e91aa', duration: '52s' },
  { id: 'r4', automation: 'Sync Shopify orders to Airtable', status: <ExecutionStatus state="failed" size="sm" />, started: 'Yesterday, 11:30', runId: 'run_8e7701', duration: '9s' },
  { id: 'r5', automation: 'Onboard new hires', status: <ExecutionStatus state="queued" size="sm" />, started: 'Scheduled, 10:00', runId: 'run_8f2c60', duration: '-' }
];

const DataSection = () => {
  return (
    <GallerySection id="data" title="Data and containers" description="Tables for lists people scan and compare. Cards group one subject. Technical values use the mono face.">
      <Table columns={COLUMNS} rows={ROWS} caption="Recent runs" />
      <div className="gallery-grid">
        <Card title="QuickBooks" description="Connected by Ana Lucia Ortega" actions={<Button size="sm">Manage</Button>}>
          <p className="gallery-panel-text">Pieve can read invoices and customers, and add notes. It cannot delete records.</p>
        </Card>
        <Card title="Loading">
          <div className="gallery-skeleton-stack">
            <div className="gallery-skeleton-row">
              <Skeleton shape="circle" />
              <div className="gallery-skeleton-lines">
                <Skeleton width="60%" />
                <Skeleton width="40%" />
              </div>
            </div>
            <Skeleton shape="block" />
          </div>
        </Card>
      </div>
      <GalleryExample label="Avatars">
        <Avatar name="Ana Lucia Ortega" size="sm" />
        <Avatar name="Marcus Lee" />
        <Avatar name="Priya Raman" size="lg" />
      </GalleryExample>
      <Card>
        <EmptyState
          icon={Plug}
          title="No connections yet"
          description="Connect the apps your team works in. Pieve uses them only for the work you ask for."
          action={
            <Button variant="primary" iconStart={Plus}>
              Connect an app
            </Button>
          }
        />
      </Card>
    </GallerySection>
  );
};

export default DataSection;
